export const USECASE_LABELS: Record<string, string> = {
  LinkedInAG: "LinkedIn · AG Serious Games",
  LinkedInGameDays: "LinkedIn · GameDays",
  LinkedInPersonal: "LinkedIn · Personal",
  FirstSpiritAG: "News · AG Serious Games",
  FirstSpiritTU: "News · TU Darmstadt",
};